export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      rating: 5,
      title: 'Seamless Executive Relocation',
      text: 'ReloExpert handled our C-suite relocation from New York to San Francisco flawlessly. Every detail was managed professionally, and our executives were settled within days.',
      name: 'Sarah Mitchell',
      role: 'VP of HR, TechCorp Global',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20woman%20headshot%20portrait%2C%20confident%20female%20executive%20in%20corporate%20attire%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20friendly%20and%20approachable%20expression%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-001&orientation=squarish',
      opacity: 1
    },
    {
      id: 2,
      rating: 5,
      title: 'Outstanding Group Move Support',
      text: 'We relocated 50 employees across three states. The coordination was impeccable, and the team provided exceptional support throughout the entire process.',
      name: 'Michael Chen',
      role: 'Operations Director, FinanceHub',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20business%20man%20headshot%20portrait%2C%20confident%20male%20executive%20in%20suit%20and%20tie%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20friendly%20smile%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-002&orientation=squarish',
      opacity: 1
    },
    {
      id: 3,
      rating: 5,
      title: 'Exceptional Destination Services',
      text: 'The destination specialists helped our international hires understand the local area, schools, and community. Their knowledge made the transition smooth and stress-free.',
      name: 'Emily Rodriguez',
      role: 'Talent Acquisition Lead, BioMed Inc',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20business%20woman%20headshot%20portrait%2C%20confident%20female%20professional%20in%20business%20attire%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20warm%20smile%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-003&orientation=squarish',
      opacity: 1
    },
    {
      id: 4,
      rating: 5,
      title: 'Reliable Corporate Housing',
      text: 'Finding temporary housing for our relocating team was effortless. ReloExpert provided quality accommodations that exceeded our expectations and budget requirements.',
      name: 'David Thompson',
      role: 'CFO, Manufacturing Solutions',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20man%20headshot%20portrait%2C%20confident%20senior%20male%20executive%20with%20gray%20hair%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20trustworthy%20expression%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-004&orientation=squarish',
      opacity: 0.85
    },
    {
      id: 5,
      rating: 5,
      title: ' Relocation Package',
      text: 'From home search to school enrollment, every aspect was covered. The attention to detail and personalized service made our company-wide relocation a success.',
      name: 'Jennifer Park',
      role: 'HR Manager, Retail Dynamics',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20business%20woman%20headshot%20portrait%2C%20confident%20female%20manager%20in%20professional%20attire%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20friendly%20demeanor%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-005&orientation=squarish',
      opacity: 0.85
    },
    {
      id: 6,
      rating: 5,
      title: 'Stress-Free International Move',
      text: 'Relocating our team from Europe to the US seemed daunting, but ReloExpert made it seamless. Their expertise in international relocations is unmatched.',
      name: 'Robert Anderson',
      role: 'Global Mobility Director, Pharma Solutions',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20business%20man%20headshot%20portrait%2C%20confident%20male%20executive%20in%20business%20suit%2C%20neutral%20background%2C%20professional%20corporate%20photography%2C%20professional%20expression%2C%20high%20quality%20business%20portrait&width=200&height=200&seq=avatar-006&orientation=squarish',
      opacity: 0.7
    }
  ];

  return (
    <section className="py-24 px-8 md:px-16 lg:px-24 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-2 h-2 rounded-full bg-orange-500"></div>
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider whitespace-nowrap">Client Success Stories</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-4 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl">
            See how we've simplified relocations for Fortune 500 companies
          </p>
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              style={{ opacity: testimonial.opacity }}
            >
              {/* Stars */}
              <div className="flex gap-2 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-xl"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {testimonial.title}
              </h3>

              {/* Text */}
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                {testimonial.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-base">
                    {testimonial.name}
                  </div>
                  <div className="text-gray-500 text-sm">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
